import FormControlLabelWithTooltip from './FormControlLabelWithTooltip';

export default FormControlLabelWithTooltip;
